







import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class LinearLoading extends Vue {
@Prop({ default: false }) loading!: boolean;
@Prop({ default: '2px' }) height!: string;
}
